import React from 'react';

import { RangeInputProps } from '@/core/components/inputs/RangeInput/RangeInput';
import RadiusLoc from '@/core/components/RadiusLoc';

export const DistanceRangeInput: React.FC<Pick<RangeInputProps, 'onChange' | 'value'>> = ({ onChange, value }) => {
  return <RadiusLoc min={0} max={100} onChange={onChange} step={5} value={value} />;
};
